import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const URL = `reports/check-dates-reporting-details`;
export const getCheckDatesReportingDetails = (axios: IAxiosInstance) => {
  return async (
    params: ISchema["#/definitions/IGetCheckDatesReportingDetailsQueryParams"]
  ) => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetCheckDatesReportingDetailsResponseBody"]
    >(URL, { params });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
